import { render, staticRenderFns } from "./hotTab.vue?vue&type=template&id=7612682e"
import script from "./hotTab.vue?vue&type=script&lang=js"
export * from "./hotTab.vue?vue&type=script&lang=js"
import style0 from "./hotTab.vue?vue&type=style&index=0&id=7612682e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports